import { ReduxCallTypesConst } from "../../../constants/ReduxCallTypesConst";
import * as requestToApi from "./RefundNPromotionCRUD";
import { refundNPromotionSlice } from "./RefundNPromotionSlice";

const { actions } = refundNPromotionSlice;
export const clearMemberRefund = () => (dispatch) => {
  dispatch(actions.clearMemberRefundFetch());
};
export const fetchMemberRefundUi = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundUiFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundListFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberRefundList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundListFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundListFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const memberRefundProcess = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundProcessFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundProcessFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const fetchMemberRefundUiClassic = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent14(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundUiFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundListFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberRefundListClassic = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent14(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundListFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundListFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const callMemberRefundEffList = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return (
    queryParams.action === "memberrefundefflist_new"
      ? requestToApi.postAgent13(queryParams)
      : requestToApi.postAgent14(queryParams)
  )
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundEffListFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundEffListFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const memberRefundProcessClassic = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent14(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundProcessFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundProcessFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const memberRefundHistory = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(actions.memberRefundHistoryFetch({ data: response.data }));
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundHistoryFetch");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
export const clearMemberRefundHistoryDetail = () => (dispatch) => {
  dispatch(actions.memberRefundHistoryDetailFetch({ data: null }));
};
export const memberRefundHistoryDetail = (queryParams) => (dispatch) => {
  dispatch(actions.startCall({ callType: ReduxCallTypesConst.ACTION }));

  return requestToApi
    .postAgent13(queryParams)
    .then((response) => {
      if (response) {
        if (!response.data.isAbort) {
          dispatch(
            actions.memberRefundHistoryDetailFetch({ data: response.data })
          );
          return response;
        }
      } else {
        throw new Error("Error api: memberRefundHistoryDetail");
      }
    })
    .catch((error) => {
      dispatch(
        actions.catchError({ error, callType: ReduxCallTypesConst.ACTION })
      );
      throw error;
    });
};
